import React, { useEffect } from "react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { useMachine } from "@xstate/react";
import { createMachine } from "xstate";

import { actions } from "./actions";
import { MACHINE_CONFIG } from "./config";
import { services } from "./services";

export const getPresentationListsContext = React.createContext({});
export let getPresentationListsMachine: any;

const MODULE_NAME = "machines.getPresentationLists";
const log: any = LoggerModule?.getInstance();

export const useSMGetPresentationLists = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  getPresentationListsMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(getPresentationListsMachine);

  useEffect(() => {
    send({ type: "START" });
  }, []);

  return {
    getPresentationListsMachine: getPresentationListsMachine,
    getPresentationListsState: state,
    getPresentationListsSend: send,
  };
};
